S<template>
  <div class="category-links py-2xl px-2xl" :class="[css]">
    <router-link
      v-for="item in children"
      :key="item.title"
      :to="item.url"
      class="category-links--thumb"
    >
      <div class="category-links--thumb--img">
        <img :src="`${$imageFolder}/${item.image}`" alt="" />
        <!--`${$imageFolder}/${item.image}`-->
      </div>
      <div class="category-links--thumb--content pt-xl text-gray-8 pb-m">
        <h3 class="font-400" v-if="item.title" v-text="item.title"></h3>
        <p class="pt-l text--m" v-if="item.summary" v-text="item.summary"></p>
      </div>

      <template v-if="item.children">
        <router-link
          v-for="child in item.children"
          :to="child.url"
          :key="child.title"
          v-text="child.title"
          class="block mt-xs"
        ></router-link>
      </template>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    children: {
      type: Array,
      required: true
    },
    css: String
  }
};
</script>

<style lang="stylus" scoped>
.category-links
  background #fff
  min-height 10vh
  _flex(column, wrap, flex-start, flex-start)
  +above(600px)
    _flex(row, wrap, stretch, space-between)
  &--thumb
    flex 0 0 30%
    margin-bottom 5vh
    // _flex(column, nowrap, flex-start, flex-start)
    text-align left
    &:first-child
      margin-left 0
    &:last-child
      margin-right 0
    &--img
      position relative
      overflow hidden
      max-height 65%
      min-height 300px
      width 100%
      backface-visibility hidden
      transform translateZ(0)
      img
        center()
        transition transform 0.5s ease-out-quad
        max-width 130%
        min-height 100%
        max-height 130%
        min-width 100%
        object-fit cover

    flex 0 0 100%
    width 100%
    +above(600px)
      flex 0 0 45%
    +above(800px)
      flex 0 0 30%
      &:hover
        img
          transform translate(-50%,-50%) scale(1.1)
</style>
